﻿import { win32 } from "path";
import accounting from 'accounting';

function checkVisible(elm) {
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
}

export function hello() {
    console.log('hello');
}

function emwbisEnd() {
    $('.email-me-when-back-in-stock-form').hide();
    $('.emwbis-thanks').fadeIn();
}
window.emwbisEnd = emwbisEnd;

function addToCartStart(data) {
    if ($('.wish-list-item-area').length > 0) { // is wish list page

    } else {
        $('.add-to-cart-button').prop('disabled', true).html('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i>' + $('.add-to-cart-button').data('adding'));
        var Locale = $('.add-to-cart-button').parents('form').find('input[name="locale"]').val();
        var Sku = $('.add-to-cart-button').parents('form').find('input[name="sku"]').val();
        var Quantity = $('.add-to-cart-button').parents('form').find('input[name="quantity"]').val();
        var Currency = $('.add-to-cart-button').parents('form').find('input[name="currency"]').val();
        var Section = $('.add-to-cart-button').parents('form').find('input[name="section"]').val();
        var Price = $('.add-to-cart-button').parents('form').find('input[name="price"]').val();
        var ProductName = $('.add-to-cart-button').parents('form').find('input[name="productname"]').val();

        if (typeof dataLayer != "undefined") {
            dataLayer.push({
                'event': 'addToCart',
                'pageType': 'confirmation',
                'pageCountry': Locale, // the language-country combination for the page seen
                'ecommerce': {
                    'currencyCode': Currency,
                    'add': {
                        'products': [{
                            'name': ProductName,
                            'id': Sku,
                            'quantity': Quantity,
                            'price': (Price * Quantity),
                            'category': Section
                        }]
                    }
                }
            });
        }
    }
}
window.addToCartStart = addToCartStart;

function addToCartEnd(data) {
    $('.add-to-cart-button').prop('disabled', false).html($('.add-to-cart-button').data('add-to-cart'));
    $('.add-to-cart-product-card-button').prop('disabled', false).val($('.add-to-cart-button').data('add-to-cart'));
    //console.log('dddd');

    //console.log(data);
    if (data != null && data.responseJSON != null) {
        $('.add-to-basket-success-alert').removeClass('d-none');
        if (data.responseJSON.addToCartProduct != null) {
            $('.added-to-basket-confirmation').text(data.responseJSON.addToCartQuantity + " x " + data.responseJSON.addToCartProduct.productName);
        }
        $('.view-basket-link').attr('href', data.responseJSON.cartSection.url);
        $('.mini-cart-area .mini-cart').remove();
        $('.mini-cart-area').append(data.responseJSON.html);

        $('.mini-cart-area .lazy').Lazy();

        $('.mini-cart-area .badge, .ss-basket-link .badge').text(data.responseJSON.productQuantity);

        var dropdown = $('.dropdown.mini-cart-area');
        if (checkVisible(dropdown[0])) {
            var menu = $('.dropdown-menu', dropdown);
            dropdown.addClass('show');
            menu.addClass('show');

            setTimeout(function () {
                if (!dropdown.is(':hover')) {
                    dropdown.removeClass('show');
                    menu.removeClass('show');
                }
            }, 5000);
        } else {
            var stickyCart = $('.mini-cart-area--sticky .mini-cart');
            stickyCart.addClass('show');

            setTimeout(function () {
                if (!stickyCart.is(':hover')) {
                    stickyCart.removeClass('show');
                }
            }, 5000);
        }

        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof fbq !== 'undefined') {
                fbq('track', 'AddToCart');
            }
        }, false);
    }
}
window.addToCartEnd = addToCartEnd;

function changeCartEnd(data) {
    if (data != null && data.responseJSON != null) {
        if ($('.voucher-form').length > 0 || $('.wish-list-item-area').length > 0) {
            var CurrencySymbol = $('#CurrencySymbol').text();
            var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
            var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();

            $('.mini-cart-area .mini-cart').remove();
            $('.mini-cart-area').append(data.responseJSON.html);

            $('.mini-cart-area .badge, .ss-basket-link .badge').text(data.responseJSON.productQuantity);

            $.each(data.responseJSON.items, function () {
                var form = $('form[data-sku="' + this.groupProdCode + '"][data-byo="' + (this.buildYourOwnProductId || '') + '"]');
                form.find('.CartProductQuantity').val(this.quantity).attr('max', this.product.stockLevel);
                form.find('.CartLinePrice').text(accounting.formatMoney(this.price, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
                if (this.giftWrappingPrice == null) {
                    form.find('.CartGiftWrapLinePrice').text('');
                    form.find('input[name="giftwrap"]').prop('checked', false);
                } else {
                    form.find('.CartGiftWrapLinePrice').text(accounting.formatMoney(this.giftWrappingPrice, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
                    form.find('input[name="giftwrap"]').prop('checked', true);
                }
            });

            $('.CartTotal').text(accounting.formatMoney(data.responseJSON.total, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator));
        } else {
            location.reload();
        }        
    }
}
window.changeCartEnd = changeCartEnd;

function addVoucherEnd(data) {
    //console.log(data.responseJSON.voucher.status);
    if (data.responseJSON.voucher.status) {
        $('.voucher-form .message-area').addClass('d-none').removeClass('d-block');
        // voucher is good

        if ($('.cart-page').length > 0) {
            location.reload();
        } else {
            location.reload(); // temporary
            // it's the check out page, so must be done dynamically
            var CurrencySymbol = $('#CurrencySymbol').text();
            var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
            var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();

            if (data.responseJSON.voucher.discountAmount > 0) {
                $('.voucher-discount-row').removeClass('d-none');
            } else {
                $('.voucher-discount-row').addClass('d-none');
            }
            $('.voucher-info-area').show();
            $('.voucher-form').hide();
            $('.voucher-desc').text(data.responseJSON.voucher.message);
            //console.log(data.responseJSON.voucher.discountAmountAsCurrency);
            $('.VoucherDiscountAmount').text(data.responseJSON.voucher.discountAmountAsCurrency).data('value', data.responseJSON.voucher.discountAmount);

            $('#CheckoutDeliveryOptionsArea .ShippingOption').addClass('d-none').addClass('ShippingOptionHidden');
            $.each(data.responseJSON.shippingOptions, function (i, so) {
                $('#CheckoutDeliveryOptionsArea .ShippingOption input[name="Order.ShippingMethodId"][value="' + so.id + '"]').parents('.ShippingOption').removeClass('ShippingOptionHidden');
            });
            $('#CheckoutDeliveryOptionsArea .ShippingOption:not(.ShippingOptionHidden)[data-zone="' + data.responseJSON.shippingZone + '"]').removeClass('d-none');

            var standardShipping = $('.standard-shipping:visible');
            if (data.responseJSON.voucher.freeShipping && data.responseJSON.voucher.voucherCountryIso != null && data.responseJSON.voucher.deliveryCountryIso != null && data.responseJSON.voucher.deliveryCountryIso.toLowerCase() == data.responseJSON.voucher.voucherCountryIso.toLowerCase()) {
                standardShipping.find('input:visible').data('cost', 0);
                var deliveryCostAsCurrency = standardShipping.data('freetext');
                standardShipping.parents('.ShippingOption').find('.ShippingOptionCost').text(deliveryCostAsCurrency);
            }

            $('#CheckoutDeliveryOptionsArea .ShippingOption input[name="Order.ShippingMethodId"][value="' + data.responseJSON.shippingMethodId + '"]').prop('checked', true).trigger('change');
            CheckFirstShippingOption();

            var selectedShippingOptionCost = parseFloat($('.ShippingOption input:checked').data('cost'));
            var selectedShippingOptionCostFormatted = $('.ShippingOption input:checked').parents('.ShippingOption').find('.ShippingOptionCost').text();
            $('.ShippingCost').text(selectedShippingOptionCostFormatted).data('value', selectedShippingOptionCost);

            //var calculatedCost = parseFloat($('.Subtotal').data('value')) + selectedShippingOptionCost;
            //console.log('calculatedCost: ' + calculatedCost);
            //if ($('.voucher-discount-row:visible').length > 0) {
            //    calculatedCost -= parseFloat($('.VoucherDiscountAmount').data('value'));
            //    console.log('calculatedCost (post discount): ' + calculatedCost);
            //}

            //if (!$('.sales-tax-exemption-row').hasClass('d-none')) {
            //    var SalesTaxValue = parseFloat($('#SalesTaxValue').text());
            //    var calculatedCostExTax = calculatedCost / SalesTaxValue;
            //    var calculatedSalesTaxExemption = calculatedCost - calculatedCostExTax;

            //    var SalesTaxExemption = accounting.formatMoney(calculatedSalesTaxExemption, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
            //    $('.SalesTaxExemption').text(SalesTaxExemption).data('value', calculatedSalesTaxExemption);

            //    calculatedCost = calculatedCostExTax;
            //}

            //var Total = accounting.formatMoney(calculatedCost, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);

            //if (calculatedCost > 0) {
            //    $('.stripe-form-area').removeClass('d-none');
            //} else {
            //    $('.stripe-form-area').addClass('d-none');
            //}
            //$('.OrderTotal').text(Total).data('value', calculatedCost);
            //console.log(calculatedCost);
            
            if (data.responseJSON.showSalesTaxExemption) {
                $('.sales-tax-exemption-row').removeClass('d-none');
                var SalesTaxExemption = accounting.formatMoney(data.responseJSON.salesTaxExemption, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
                $('.SalesTaxExemption').text(SalesTaxExemption).data('value', data.responseJSON.salesTaxExemption);
            } else {
                $('.sales-tax-exemption-row').addClass('d-none');
            }

            if (data.responseJSON.total > 0) {
                $('.stripe-form-area').removeClass('d-none');
            } else {
                $('.stripe-form-area').addClass('d-none');
            }
            //console.log(data.responseJSON.total);
            var Total = accounting.formatMoney(data.responseJSON.total, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
            $('.OrderTotal').text(Total).data('value', data.responseJSON.total);

        }
    } else {
        $('.voucher-form .message-area .alert').text(data.responseJSON.voucher.message);
        $('.voucher-form .message-area').removeClass('d-none').addClass('d-block');
    }
}
window.addVoucherEnd = addVoucherEnd;

function CheckoutAccountComplete(data) {
    if (data.responseJSON.success) {
        if (typeof ga !== 'undefined') {
            if (data.responseJSON.newUser) {
                ga('gtm1.send', 'event', 'checkout form', 'complete', 'continue as guest');
            } else {
                ga('gtm1.send', 'event', 'checkout form', 'complete', 'returning customer');
            }
        }
        window.location.reload(true);
    } else if (data.responseJSON.errorRedirectUrl != null) {
        window.location = data.responseJSON.errorRedirectUrl;
    } else if (data.responseJSON.errorMessage != null) {
        var message = data.responseJSON.newUser ? $('[data-valmsg-for="Order.NewCustomerEmail"]') : $('[data-valmsg-for="Login.Password"]');
        message.removeClass('field-validation-valid').addClass('field-validation-error').html(data.responseJSON.errorMessage);
        $('#CheckoutAccountArea .btn').removeAttr('disabled').removeClass('disabled').find('.showWhenDisabled').removeClass('d-none');
    } else {
        $('#CheckoutAccountArea .btn').removeAttr('disabled').removeClass('disabled').find('.showWhenDisabled').removeClass('d-none');
    }
}
window.CheckoutAccountComplete = CheckoutAccountComplete;

function CheckoutDeliveryAddressBegin() {
    var RegionDropdown = $('select[name="Order.DeliveryAddress.Region"]:enabled');
    if (RegionDropdown.length > 0 && (RegionDropdown.val() === null || RegionDropdown.val() === '')) {
        $('#CheckoutAddressArea .btn').removeAttr('disabled').removeClass('disabled');
        $('#EditDeliveryAddress').trigger('click');
        return false;
    }
    return true;
}
window.CheckoutDeliveryAddressBegin = CheckoutDeliveryAddressBegin;

function CheckoutDeliveryAddressComplete(data) {
    if (data.responseJSON.success) {
        if (typeof ga !== 'undefined') {
            ga('gtm1.send', 'event', 'checkout form', 'complete', 'delivery address');
        }

        $('#CheckoutAddressArea').slideUp(function () {
            $(this).addClass('collapsed-area').find('.btn').removeAttr('disabled').removeClass('disabled');
            $('#CheckoutAddressSummary').text(data.responseJSON.summary).parents('.card-body').removeClass('d-none').hide().slideDown();
            $('#CheckoutAddressEdit').removeClass('d-none').hide().fadeIn();
            $('#CheckoutDeliveryOptionsArea').removeClass('collapsed-area').hide().slideDown();

            $('.DeliveryAddress').text(data.responseJSON.deliveryAddressString);
            $('input[name="Order.DeliveryAddress.Id"]').val(data.responseJSON.deliveryAddress.id);
            $('input[name="Order.DeliveryAddress.FirstName"]').val(data.responseJSON.deliveryAddress.firstName);
            $('input[name="Order.DeliveryAddress.LastName"]').val(data.responseJSON.deliveryAddress.lastName);
            $('input[name="Order.DeliveryAddress.Line1"]').val(data.responseJSON.deliveryAddress.line1);
            $('input[name="Order.DeliveryAddress.Line2"]').val(data.responseJSON.deliveryAddress.line2);
            $('input[name="Order.DeliveryAddress.TownCity"]').val(data.responseJSON.deliveryAddress.townCity);
            $('input[name="Order.DeliveryAddress.Region"], select[name="Order.DeliveryAddress.Region"]').val(data.responseJSON.deliveryAddress.region);
            $('input[name="Order.DeliveryAddress.Postcode"]').val(data.responseJSON.deliveryAddress.postcode);
            $('select[name="Order.DeliveryAddress.CountryIso"]').val(data.responseJSON.deliveryAddress.countryIso);
            $('select[name="Order.DeliveryTelephone"]').val(data.responseJSON.deliveryAddress.telephone);

            $('[name^="Order.DeliveryAddress."], [name="Order.DeliveryTelephone"]').each(function () {
                $(this).data('original', $(this).val());
            });

            //Update select address modal
            if (data.responseJSON.oldAddressId != null) {
                $('#SelectAddressModal .SelectAddressModal--address[data-id="' + data.responseJSON.oldAddressId + '"]').remove();
            }
            if ($('#SelectAddressModal .SelectAddressModal--address[data-id="' + data.responseJSON.deliveryAddress.id + '"]').length === 0) {
                var newAddress = $('<div>').addClass('col-sm-6 col-lg-4 mb-2').append($('<div>').addClass('h-100 p-3 pre-wrap SelectAddressModal--address').attr('data-id', data.responseJSON.deliveryAddress.id).attr('data-address', JSON.stringify(data.responseJSON.deliveryAddress)).text(data.responseJSON.deliveryAddressString));
                $('#SelectAddressModal .modal-body .form-row').append(newAddress);
            }

            if (data.responseJSON.deliveryAddress.userGuid != null) {
                $('#CurrentDeliveryAddressArea').removeClass('d-none');
                $('#NewDeliveryAddressArea').addClass('d-none');
                $('.CancelNewDeliveryAddress--area').removeClass('d-none');
                $('.UseDeliveryAddressAsBillingAddress--area').addClass('d-none');
                $('input[name="UseDeliveryAddressAsBillingAddress"]').prop('checked', false);
                $('.DefaultDeliveryAddress--area').removeClass('d-none');
            }

            $('#CheckoutDeliveryOptionsArea .ShippingOption').addClass('d-none');
            $('#CheckoutDeliveryOptionsArea .ShippingOption:not(.ShippingOptionHidden)[data-zone="' + data.responseJSON.shippingZone + '"]').removeClass('d-none');

            //modify deleivery address cost if there's a voucher etc.
            //console.log(data.responseJSON.voucher.countryIso.toLowerCase());
            //console.log(data.responseJSON.deliveryAddress.countryIso.toLowerCase());

            var standardShipping = $('.standard-shipping:visible');
            if (data.responseJSON.voucher != null && data.responseJSON.voucher.freeShipping && data.responseJSON.voucher.countryIso != null && data.responseJSON.voucher.countryIso.toLowerCase() == data.responseJSON.deliveryAddress.countryIso.toLowerCase()) {
                standardShipping.find('input:visible').data('cost', 0);
                var deliveryCostAsCurrency = standardShipping.data('freetext');
                standardShipping.parents('.ShippingOption').find('.ShippingOptionCost').text(deliveryCostAsCurrency);
            } else {
                var normalCost = standardShipping.find('input:visible').data('normal-cost');
                standardShipping.find('input:visible').data('cost', normalCost);
                //console.log(normalCost);
                var CurrencySymbol = $('#CurrencySymbol').text();
                var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
                var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();
                var standardShippingCostFormatted = accounting.formatMoney(normalCost, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
                standardShipping.parents('.ShippingOption').find('.ShippingOptionCost').text(standardShippingCostFormatted);
            }

            $('#CheckoutPaymentArea .BillingAddress').text(data.responseJSON.billingAddressString);
            if (data.responseJSON.billingAddress != null) {
                $('#CurrentBillingAddressArea').removeClass('d-none');
                $('#NewBillingAddressArea').addClass('d-none');
                $('#CancelNewBillingAddressArea').removeClass('d-none');

                $('input[name="Order.BillingAddress.Id"]').val(data.responseJSON.billingAddress.id);
                $('input[name="Order.BillingAddress.FirstName"]').val(data.responseJSON.billingAddress.firstName);
                $('input[name="Order.BillingAddress.LastName"]').val(data.responseJSON.billingAddress.lastName);
                $('input[name="Order.BillingAddress.Line1"]').val(data.responseJSON.billingAddress.line1);
                $('input[name="Order.BillingAddress.Line2"]').val(data.responseJSON.billingAddress.line2);
                $('input[name="Order.BillingAddress.TownCity"]').val(data.responseJSON.billingAddress.townCity);
                $('input[name="Order.BillingAddress.Region"], select[name="Order.BillingAddress.Region"]').val(data.responseJSON.billingAddress.region);
                $('input[name="Order.BillingAddress.Postcode"]').val(data.responseJSON.billingAddress.postcode);
                $('select[name="Order.BillingAddress.CountryIso"]').val(data.responseJSON.billingAddress.countryIso);

                $('[name^="Order.BillingAddress."]').each(function () {
                    $(this).data('original', $(this).val());
                });
            } else {
                $('#CurrentBillingAddressArea').addClass('d-none');
                $('#NewBillingAddressArea').removeClass('d-none');
                $('#CancelNewBillingAddressArea').addClass('d-none');

                $('[name^="Order.BillingAddress."]').val(function () {
                    return $(this).data('default');
                });
                $('[name^="Order.BillingAddress."]').each(function () {
                    $(this).data('original', $(this).val());
                });
            }

            if (data.responseJSON.showSalesTaxExemption) {
                $('.sales-tax-exemption-row').removeClass('d-none');
            } else {
                $('.sales-tax-exemption-row').addClass('d-none');
            }

            CheckFirstShippingOption();
        });
    } else if (data.responseJSON.errorRedirectUrl != null) {
        window.location = data.responseJSON.errorRedirectUrl;
    } else {
        if (data.responseJSON.errorMessage) {
            alert(data.responseJSON.errorMessage);
        } else {
            alert('An unknown error occurred. Please try again.');
        }
        $('#CheckoutAddressArea .btn').removeAttr('disabled').removeClass('disabled');
    }
}
window.CheckoutDeliveryAddressComplete = CheckoutDeliveryAddressComplete;

function CheckoutDeliveryOptionsComplete(data) {
    if (data.responseJSON.success) {
        if (typeof ga !== 'undefined') {
            ga('gtm1.send', 'event', 'checkout form', 'complete', 'delivery options');
        }

        $('#CheckoutDeliveryOptionsArea').slideUp(function () {
            $(this).addClass('collapsed-area').find('.btn').removeAttr('disabled').removeClass('disabled');
            $('#CheckoutDeliveryOptionsSummary').text(data.responseJSON.summary).parents('.card-body').removeClass('d-none').hide().slideDown();
            $('#CheckoutDeliveryOptionsEdit').removeClass('d-none').hide().fadeIn();
            $('#CheckoutPaymentArea').removeClass('collapsed-area').hide().slideDown();

            if (data.responseJSON.freeShipping) {
                $('.ShippingCost').text($('.standard-shipping').data("freetext"));
            } else {
                $('.ShippingCost').text(data.responseJSON.shippingCost);
            }
            $('.SalesTaxExemption').text(data.responseJSON.salesTaxExemption);
            $('.OrderTotal').text(data.responseJSON.orderTotal);

            if (data.responseJSON.showSalesExemption) {
                $('.sales-tax-exemption-row').removeClass('d-none');
            } else {
                $('.sales-tax-exemption-row').addClass('d-none');
            }

            $('.ShippingAndTotal').removeClass('d-none').hide().fadeIn();

            if (data.responseJSON.total > 0) {
                $('.stripe-form-area').removeClass('d-none');
            } else {
                $('.stripe-form-area').addClass('d-none');
            }
            //console.log(data.responseJSON.total);
        });
    } else if (data.responseJSON.errorRedirectUrl != null) {
        window.location = data.responseJSON.errorRedirectUrl;
    } else {
        if (data.responseJSON.errorMessage) {
            alert(data.responseJSON.errorMessage);
        } else {
            alert('An unknown error occurred. Please try again.');
        }
        $('#CheckoutDeliveryOptionsArea .btn').removeAttr('disabled').removeClass('disabled');
    }
}
window.CheckoutDeliveryOptionsComplete = CheckoutDeliveryOptionsComplete;

function CheckoutPaymentComplete(data) {
    if (data.responseJSON.success) {
        if (typeof ga !== 'undefined') {
            ga('gtm1.send', 'event', 'checkout form', 'complete', 'payment');
        }

        window.location = data.responseJSON.redirectUrl;
    } else {
        var cardElement = $('#card-element');
        var cardErrors = $('#card-errors');
        if (data.responseJSON.errorRedirectUrl != null) {
            window.location = data.responseJSON.errorRedirectUrl;
        } else if (data.responseJSON.stripeError) {
            cardElement.addClass('StripeElement--invalid');
            cardErrors.text(data.responseJSON.stripeError);
        } else if (data.responseJSON.stripeRequiresAction) {
            stripe.handleCardAction(
                data.responseJSON.stripePaymentIntentClientSecret
            ).then(function (result) {
                if (result.error) {
                    cardElement.addClass('StripeElement--invalid');
                    cardErrors.text(result.error.message);
                } else {
                    // The card action has been handled
                    // The PaymentIntent can be confirmed again on the server
                    $('input[name="StripePaymentMethodId"]').val(''); //clear Stripe payment method
                    $('input[name="StripePaymentIntentId"]').val(result.paymentIntent.id);
                    $('#PaymentForm').submit(); // re-submit form
                }
            });
        } else {
            cardElement.removeClass('StripeElement--invalid');
            cardErrors.text('');

            if (data.responseJSON.errorMessage) {
                alert(data.responseJSON.errorMessage);
            } else {
                alert('An unknown error occurred. Please try again.');
            }

            location.reload();
        }
        $('input[name="StripePaymentMethodId"]').val(''); //clear Stripe payment method
        $('input[name="StripePaymentIntentId"]').val(''); //clear Stripe payment intent
        $('#CheckoutPaymentArea .btn').removeAttr('disabled').removeClass('disabled');
        $('.CheckoutStepEdit').show();
    }
}
window.CheckoutPaymentComplete = CheckoutPaymentComplete;

function CheckFirstShippingOption() {
    if ($('#CheckoutDeliveryOptionsArea input[name="Order.ShippingMethodId"]:visible:checked').length == 0) {
        $('#CheckoutDeliveryOptionsArea:visible input[name="Order.ShippingMethodId"]:visible').first().prop('checked', true);
    }
    $('#CheckoutDeliveryOptionsArea input[name="Order.ShippingMethodId"]:checked').trigger('change');
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var stripe;
$(function () {
    var ExternalLoginProvider = getParameterByName('ExternalLoginProvider');
    if (ExternalLoginProvider != null) {
        if (typeof ga !== 'undefined') {
            ga('gtm1.send', 'event', 'checkout form', 'complete', ExternalLoginProvider + ' sign in');
        }
        if (history.replaceState) {
            var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.replaceState({}, document.title, newurl);
        }
    }

    $('.voucher-code-link').on('click', function (e) {
        $(this).addClass('d-none');
        //$('.voucher-form').fadeIn();
        $('.voucher-form').fadeIn(function () {
            $('#voucherCode').focus();
        });
        return false;
    });

    $('.add-to-cart-button-standard-variant').on('click', function (e) {
        $(this).prop('disabled', true).html('<i class="fa fa-circle-o-notch fa-spin fa-fw"></i>' + $(this).data('adding'));
        var qty = $(this).parents('tr').find('input[name=skuquantity]').val();
        var sku = $(this).data('sku');
        var form = $(this).parents('form');
        form.find('input[name=quantity]').val(qty);
        form.find('input[name=sku]').val(sku);
        form.submit();

        //return false;
    });

    $('.cart-page-remove-voucher-link').on('click', function (e) {
        e.preventDefault();
        $.post('/RemoveVoucher', { Locale: $(this).data('locale') }, function () {
            location.reload();
        });
    });
    
    $('.remove-voucher-btn').on('click', function (e) {
        var CurrencySymbol = $('#CurrencySymbol').text();
        var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
        var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();

        $.post('/RemoveVoucher', { Locale: $(this).data('locale') }, function (data) {
            location.reload(); // temp
            $('.voucher-info-area').hide();
            $('.voucher-discount-row').addClass('d-none');
            $('.voucher-form #voucherCode').val('');
            $('.voucher-code-link').removeClass('d-none');

            $('#CheckoutDeliveryOptionsArea .ShippingOption').addClass('d-none').addClass('ShippingOptionHidden');
            $.each(data.shippingOptions, function (i, so) {
                $('#CheckoutDeliveryOptionsArea .ShippingOption input[name="Order.ShippingMethodId"][value="' + so.id + '"]').parents('.ShippingOption').removeClass('ShippingOptionHidden');
            });
            $('#CheckoutDeliveryOptionsArea .ShippingOption:not(.ShippingOptionHidden)[data-zone="' + data.shippingZone + '"]').removeClass('d-none');

            $('.standard-shipping input').each(function () {
                var standardShippingCost = $(this).data("normal-cost");
                var standardShippingCostFormatted = accounting.formatMoney(standardShippingCost, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
                $(this).data("cost", standardShippingCost);
                $(this).parents('.ShippingOption').find('.ShippingOptionCost').text(standardShippingCostFormatted);
            });

            $('#CheckoutDeliveryOptionsArea .ShippingOption input[name="Order.ShippingMethodId"][value="' + data.shippingMethodId + '"]').prop('checked', true).trigger('change');
            CheckFirstShippingOption();

            var selectedShippingOptionCost = parseFloat($('.ShippingOption input:checked').data('cost'));
            var selectedShippingOptionCostFormatted = $('.ShippingOption input:checked').parents('.ShippingOption').find('.ShippingOptionCost').text();
            $('.ShippingCost').text(selectedShippingOptionCostFormatted).data('value', selectedShippingOptionCost);

            if (data.showSalesTaxExemption) {
                $('.sales-tax-exemption-row').removeClass('d-none');
                var SalesTaxExemption = accounting.formatMoney(data.salesTaxExemption, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
                $('.SalesTaxExemption').text(SalesTaxExemption).data('value', data.salesTaxExemption);
            } else {
                $('.sales-tax-exemption-row').addClass('d-none');
            }

            if (data.total > 0) {
                $('.stripe-form-area').removeClass('d-none');
            } else {
                $('.stripe-form-area').addClass('d-none');
            }
            //console.log(data.responseJSON.total);
            var Total = accounting.formatMoney(data.total, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
            $('.OrderTotal').text(Total).data('value', data.total);

            //var calculatedCost = parseFloat($('.Subtotal').data('value')) + selectedShippingOptionCost;
            //if (!$('.sales-tax-exemption-row').hasClass('d-none')) {
            //    var SalesTaxValue = parseFloat($('#SalesTaxValue').text());
            //    var calculatedCostExTax = calculatedCost / SalesTaxValue;
            //    var calculatedSalesTaxExemption = calculatedCost - calculatedCostExTax;

            //    var SalesTaxExemption = accounting.formatMoney(calculatedSalesTaxExemption, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
            //    $('.SalesTaxExemption').text(SalesTaxExemption).data('value', calculatedSalesTaxExemption);

            //    calculatedCost = calculatedCostExTax;
            //}
            //var Total = accounting.formatMoney(calculatedCost, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
            //if (calculatedCost > 0) {
            //    $('.stripe-form-area').removeClass('d-none');
            //} else {
            //    $('.stripe-form-area').addClass('d-none');
            //}
            ////console.log(calculatedCost);
            //$('.OrderTotal').text(Total).data('value', calculatedCost);

        }, "json");
    });

    $('.terms-modal-link').on('click', function (e) {
        $('.terms-modal').modal('show');
        return false;
    });

    $('.returns-modal-link').on('click', function (e) {
        $('.returns-modal').modal('show');
        return false;
    });

    $('.CartProductQuantity').on('change keyup paste', function () {
        var form = $(this).closest('form');
        setTimeout(function () {
            form.trigger('submit');
        }, 20);
        location.reload();
    });

    $('.CartProductGiftwrap').on('change', function () {
        var form = $(this).closest('form');
        form.trigger('submit');
    });

    $('.CartProductRemove').on('click', function (e) {
        var form = $(this).closest('form');
        var validationKey = form.find('[name="__RequestVerificationToken"]').val();
        var sku = form.find('[name="sku"]').val();
        var byoGuid = form.find('[name="byoGuid"]').val();
        var locale = form.find('[name="locale"]').val();
        var AddFreeProdValue = true;
        if ($(this).data('freeproduct') != null && $(this).data('freeproduct')) {
            AddFreeProdValue = false;
        }

        $.post(form.attr('action'), { sku: sku, byoGuid: byoGuid, locale: locale, quantity: 0, AddFreeProduct: AddFreeProdValue, ReplaceQty: true, __RequestVerificationToken: validationKey }, function () {
            location.reload();
        });
        form.fadeOut();
        $('.voucher-desc-area').fadeOut();

        //AddSKUToCart(string sku, int quantity, string locale, int ? variantID, bool ReplaceQty = false)

        //location.reload();
       return false;

        //e.preventDefault();

        //var quantity = form.find('.CartProductQuantity');
        //var quantityVal = quantity.val();
        //quantity.val(0);
        //form.trigger('submit');
        //quantity.val(quantityVal);

        //if ($('.CartContents > form').length > 1) {
        //    form.fadeOut(function () {
        //        form.remove();
        //    });
        //} else {
        //    $('.CartContents, .CheckoutButton').fadeOut(function () {
        //        $('.CartEmptyMessage').removeClass('d-none');
        //    });
        //}
    });

    $('.CheckoutButton').on('click', function () {
        window.addEventListener('marketingCookiesAccepted', function (e) {
            if (typeof fbq !== 'undefined') {
                fbq('track', 'InitiateCheckout');
            }
        }, false);
    });

    $('.CheckoutStepEdit').on('click', function (e) {
        e.preventDefault();
        $('.CheckoutStepArea:not(.collapsed-area)').slideUp(function () {
            $(this).addClass('collapsed-area');
        });
        var Card = $(this).parents('.card');
        Card.find('.CheckoutSummaryArea').slideUp(function () {
            $(this).addClass('d-none');
            Card.find('.CheckoutStepArea').removeClass('collapsed-area').hide().slideDown();
        });
        $(this).fadeOut().addClass('d-none');
        Card.nextAll('.card').find('.CheckoutStepEdit').fadeOut(function () {
            $(this).addClass('d-none');
        });
        Card.nextAll('.card').find('.CheckoutSummaryArea').slideUp(function () {
            $(this).addClass('d-none');
        });

        switch ($(this).attr('id')) {
            case 'CheckoutAccountEdit':
            case 'CheckoutAddressEdit':
            case 'CheckoutDeliveryOptionsEdit':
                $('.ShippingAndTotal').fadeOut(function () {
                    $(this).addClass('d-none');
                });
                break;
        }
    });

    $('.CheckoutStepArea form:not(.ExternalLoginForm)').on('submit', function () {
        if ($(this).valid()) {
            var CheckoutStepArea = $(this).parents('.CheckoutStepArea');
            CheckoutStepArea.find('form').not($(this)).find('.btn .showWhenDisabled').addClass('d-none');
            CheckoutStepArea.find('.btn').attr('disabled', 'disabled').addClass('disabled');
        }
    });

    $('#ContinueAsUser').on('click', function (e) {
        e.preventDefault();
        $('#CheckoutAccountArea').slideUp(function () {
            $(this).addClass('collapsed-area');
            $('#CheckoutAccountSummary').parents('.card-body').removeClass('d-none').hide().slideDown();
            $('#CheckoutAccountEdit').removeClass('d-none').hide().fadeIn();
            $('#CheckoutAddressArea').removeClass('collapsed-area').hide().slideDown();
        });
    });

    $('#CheckoutDeliveryOptionsArea input[name="Order.ShippingMethodId"]').on('change', function () {
    //    var CurrencySymbol = $('#CurrencySymbol').text();
    //    var CurrencyGroupSeparator = $('#CurrencyGroupSeparator').text();
    //    var CurrencyDecimalSeparator = $('#CurrencyDecimalSeparator').text();

        $('.ShippingOptionCost').removeClass('font-weight-bold');
        var ShippingOptionCost = $(this).parents('.ShippingOption').find('.ShippingOptionCost');
        ShippingOptionCost.addClass('font-weight-bold');
    //    $('.ShippingCost').text(ShippingOptionCost.text()).data('value', $(this).data('cost'));
    //    var calculatedCost = parseFloat($('.OrderTotal').data('value')) + parseFloat($(this).data('cost'));
    //    //if ($('.voucher-discount-row:visible').length > 0) {
    //    //    calculatedCost -= parseFloat($('.VoucherDiscountAmount').data('value'));
    //    //}
    //    //if (!$('.sales-tax-exemption-row').hasClass('d-none')) {
    //    //    var SalesTaxValue = parseFloat($('#SalesTaxValue').text());
    //    //    var calculatedCostExTax = calculatedCost / SalesTaxValue;
    //    //    var calculatedSalesTaxExemption = calculatedCost - calculatedCostExTax;

    //    //    var SalesTaxExemption = accounting.formatMoney(calculatedSalesTaxExemption, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
    //    //    $('.SalesTaxExemption').text(SalesTaxExemption).data('value', calculatedSalesTaxExemption);

    //    //    calculatedCost = calculatedCostExTax;
    //    //}
    //    //var Total = accounting.formatMoney(calculatedCost, CurrencySymbol, 2, CurrencyGroupSeparator, CurrencyDecimalSeparator);
    //    //$('.OrderTotal').text(Total).data('value', calculatedCost);

    //    if (calculatedCost > 0) {
    //        $('.stripe-form-area').removeClass('d-none');
    //    } else {
    //        $('.stripe-form-area').addClass('d-none');
    //    }
    //    //console.log(calculatedCost);
    //    $('.ShippingAndTotal').removeClass('d-none').hide().fadeIn();

    });

    CheckFirstShippingOption();

    $('[name^="Order.DeliveryAddress."], [name="Order.DeliveryTelephone"], [name^="Order.BillingAddress."]').each(function () {
        $(this).data('original', $(this).val());
    });

    $('#AddNewDeliveryAddress').on('click', function (e) {
        e.preventDefault();
        $('#CurrentDeliveryAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#NewDeliveryAddressArea').removeClass('d-none').hide().slideDown();
        });

        $('[name^="Order.DeliveryAddress."], [name="Order.DeliveryTelephone"]').val(function () {
            return $(this).data('default');
        }).trigger('change');
    });

    $('#EditDeliveryAddress').on('click', function (e) {
        e.preventDefault();
        $('#CurrentDeliveryAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#NewDeliveryAddressArea').removeClass('d-none').hide().slideDown(function () {
                $('#DeliveryAddressForm').valid();
            });
        });

        $('[name^="Order.DeliveryAddress."], [name="Order.DeliveryTelephone"]').val(function () {
            return $(this).data('original');
        }).trigger('change');

        $('[name="Order.DeliveryAddress.Id"]').val(function () {
            return $(this).data('default');
        });

        $('[name="Order.DeliveryAddress.OldAddressId"]').val(function () {
            return $('[name="Order.DeliveryAddress.Id"]').data('original');
        });
    });

    $('#CancelNewDeliveryAddress').on('click', function (e) {
        e.preventDefault();
        $('#NewDeliveryAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#CurrentDeliveryAddressArea').removeClass('d-none').hide().slideDown();

            $('[name^="Order.DeliveryAddress."], [name="Order.DeliveryTelephone"]').val(function () {
                return $(this).data('original');
            }).trigger('change');
        });
    });

    $('#AddNewBillingAddress').on('click', function (e) {
        e.preventDefault();
        $('#CurrentBillingAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#NewBillingAddressArea').removeClass('d-none').hide().slideDown();
        });
        
        $('[name^="Order.BillingAddress."]').val(function () {
            return $(this).data('default');
        }).trigger('change');
    });

    $('#EditBillingAddress').on('click', function (e) {
        e.preventDefault();
        $('#CurrentBillingAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#NewBillingAddressArea').removeClass('d-none').hide().slideDown();
        });

        $('[name^="Order.BillingAddress."]').val(function () {
            return $(this).data('original');
        }).trigger('change');

        $('[name="Order.BillingAddress.Id"]').val(function () {
            return $(this).data('default');
        });

        $('[name="Order.BillingAddress.OldAddressId"]').val(function () {
            return $('[name="Order.BillingAddress.Id"]').data('original');
        });
    });

    $('#CancelNewBillingAddress').on('click', function (e) {
        e.preventDefault();
        $('#NewBillingAddressArea').slideUp(function () {
            $(this).css('display', '').addClass('d-none');
            $('#CurrentBillingAddressArea').removeClass('d-none').hide().slideDown();

            $('[name^="Order.BillingAddress."]').val(function () {
                return $(this).data('original');
            }).trigger('change');
        });
    });

    $('#SelectAddressModal').on('show.bs.modal', function (e) {
        var AddressType = '';
        switch ($(e.relatedTarget).attr('id')) {
            case 'SelectDeliveryAddress':
                AddressType = 'DeliveryAddress';
                break;
            case 'SelectBillingAddress':
                AddressType = 'BillingAddress';
                break;
        }
        $(this).data('address-type', AddressType);
        $('#SelectAddressModal .SelectAddressModal--address').removeClass('selected');
        $('#SelectAddressModal .SelectAddressModal--address[data-id="' + $('[name="Order.' + AddressType + '.Id"]').val() + '"]').addClass('selected');
    });

    $('#SelectAddressModal').on('click', '.SelectAddressModal--address', function () {
        $('#SelectAddressModal .SelectAddressModal--address').removeClass('selected');
        $(this).addClass('selected');
    });

    $('#SelectAddressModalSubmit').on('click', function () {
        var AddressType = $('#SelectAddressModal').data('address-type');
        var selected = $('#SelectAddressModal .SelectAddressModal--address.selected');

        if ($('select[name="Order.' + AddressType + '.CountryIso"] option[value="' + selected.data('address').countryIso + '"]').length !== 0) {
            $('input[name="Order.' + AddressType + '.Id"]').val(selected.data('address').id);
            $('input[name="Order.' + AddressType + '.FirstName"]').val(selected.data('address').firstName);
            $('input[name="Order.' + AddressType + '.LastName"]').val(selected.data('address').lastName);
            $('input[name="Order.' + AddressType + '.Line1"]').val(selected.data('address').line1);
            $('input[name="Order.' + AddressType + '.Line2"]').val(selected.data('address').line2);
            $('input[name="Order.' + AddressType + '.TownCity"]').val(selected.data('address').townCity);
            $('input[name="Order.' + AddressType + '.Region"], select[name="Order.' + AddressType + '.Region"]').val(selected.data('address').region);
            $('input[name="Order.' + AddressType + '.Postcode"]').val(selected.data('address').postcode);
            $('select[name="Order.' + AddressType + '.CountryIso"]').val(selected.data('address').countryIso).trigger('change');

            $('[name^="Order.' + AddressType + '."]').each(function () {
                $(this).data('original', $(this).val());
            });

            $('.' + AddressType).text(selected.text());

            if (AddressType == 'DeliveryAddress') {
                $('input[name="Order.DeliveryTelephone"]').val(selected.data('address').telephone);
            }

            $('#SelectAddressModal').modal('hide');
        } else {
            alert('Sorry, this address cannot be used here.');
        }
    });

    if ($('#PaymentForm').length > 0) {
        $('input[name="StripePaymentMethodId"]').val(''); // clear Stripe payment method on page reload
        $('input[name="StripePaymentIntentId"]').val(''); //clear Stripe payment intent
        
        stripe = Stripe($('.checkout-page').data('stripe-key'));
        var elements = stripe.elements();

        // Create an instance of the card Element
        var card = elements.create('card', {
            hidePostalCode: true
        });

        // Add an instance of the card Element into the 'card-element' <div>
        card.mount('#card-element');

        function SetStripeOutcome(result) {
            var cardElement = $('#card-element');
            var cardErrors = $('#card-errors');
            if (result.error) {
                cardElement.addClass('StripeElement--invalid');
                cardErrors.text(result.error.message);

                $('#CheckoutPaymentArea .btn').removeAttr('disabled').removeClass('disabled');
                $('.CheckoutStepEdit').show();
            } else {
                cardElement.removeClass('StripeElement--invalid');
                cardErrors.text('');

                if (result.paymentMethod) {
                    window.addEventListener('marketingCookiesAccepted', function (e) {
                        if (typeof fbq !== 'undefined') {
                            fbq('track', 'AddPaymentInfo');
                        }
                    }, false);
                    $('input[name="StripePaymentMethodId"]').val(result.paymentMethod.id);
                    $('#PaymentForm').submit(); // re-submit form - default ajax submit will be allowed this time as Stripe payment method has been set
                }
            }
        }

        card.addEventListener('change', function (e) {
            SetStripeOutcome(e);
        });

        function CreateStripePaymentMethod() {
            var addressDetails = {
                billing_details: {
                    name: $.trim($('input[name="Order.BillingAddress.FirstName"]').val()) + ' ' + $.trim($('input[name="Order.BillingAddress.LastName"]').val()),
                    address: {
                        line1: $.trim($('input[name="Order.BillingAddress.Line1"]').val()),
                        line2: $.trim($('input[name="Order.BillingAddress.Line2"]').val()),
                        city: $.trim($('input[name="Order.BillingAddress.TownCity"]').val()),
                        state: $.trim($('input[name="Order.BillingAddress.Region"], select[name="Order.BillingAddress.Region"]').filter(':enabled').val()),
                        postal_code: $.trim($('input[name="Order.BillingAddress.Postcode"]').val()),
                        country: $.trim($('select[name="Order.BillingAddress.CountryIso"]').val())
                    }
                }
            };
            //TODO: test this in IE - pretty sure it won't work due to no Promise support?
            //stripe.createToken(card, addressDetails).then(SetStripeOutcome);

            stripe.createPaymentMethod('card', card, addressDetails).then(SetStripeOutcome);
        }

        $('#PaymentForm').on('submit', function () {
            if ($('.stripe-form-area:visible').length > 0) {
                if ($('#PaymentForm').valid() && $('input[name="StripePaymentMethodId"]').val() == '' && $('input[name="StripePaymentIntentId"]').val() == '') {
                    $('.CheckoutStepEdit').hide();
                    CreateStripePaymentMethod();
                    return false; // prevent default ajax submit if Stripe payment method/intent has not been set
                }
            }
        });
    }
});
